// extracted by mini-css-extract-plugin
module.exports = {"item":"SectionSeparator_item_Sqo2m"};